import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getTheme, toggleTheme } from '../utils/theme';

const { FiMenu, FiMoon, FiSearch, FiSun, FiX } = FiIcons;

function Header({ onSearch }) {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(getTheme());

  const onToggleTheme = () => setTheme(toggleTheme());

  return (
    <header className="top-nav">
      <nav className="nav-inner" aria-label="Main navigation">
        <a className="brand" href="/" aria-label="DeepMagic home">
          <span className="brand-mark">
            <svg viewBox="0 0 64 64" width="22" height="22" aria-hidden="true">
              <defs>
                <linearGradient id="dm-nav-bg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#6D28D9" />
                  <stop offset="1" stop-color="#3B0764" />
                </linearGradient>
              </defs>
              <rect width="64" height="64" rx="16" fill="url(#dm-nav-bg)" />
              <path d="M18 17h8c9 0 15 6 15 15s-6 15-15 15h-8V17zm7 7v16h1c5 0 8-3 8-8s-3-8-8-8h-1z" fill="#fff" />
              <path d="M48.5 21.5a2.5 2.5 0 0 1 2.5 2.5v16a2.5 2.5 0 0 1-5 0V24a2.5 2.5 0 0 1 2.5-2.5z" fill="#A78BFA" />
            </svg>
          </span>
          <span>DeepMagic</span>
        </a>

        <div className="desktop-links">
          <a className="nav-link active" href="#directory">Apps</a>
          <a className="nav-link" href="#about">About</a>
        </div>

        <div className="nav-actions">
          <button
            className="nav-search theme-toggle"
            type="button"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            onClick={onToggleTheme}
          >
            <SafeIcon icon={theme === 'dark' ? FiSun : FiMoon} />
          </button>
          <button className="nav-search" type="button" onClick={onSearch}>
            <SafeIcon icon={FiSearch} />
            <span>Search</span>
            <kbd>⌘K</kbd>
          </button>
          <a className="primary-button desktop-submit" href="https://files.deepmagic.app/files/shared/common/">
            + Share a file
          </a>
          <button
            className="menu-button"
            type="button"
            aria-label="Toggle navigation"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            <SafeIcon icon={open ? FiX : FiMenu} />
          </button>
        </div>

        {open && (
          <div className="mobile-menu">
            <a href="#directory" onClick={() => setOpen(false)}>Apps</a>
            <a href="#about" onClick={() => setOpen(false)}>About</a>
            <a className="primary-button" href="https://files.deepmagic.app/files/shared/common/">
              + Share a file
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;
